<template>
	<b-navbar-nav>
		<b-nav-item-dropdown right no-caret>
			<template slot="button-content">
				<i id="user-menu-button" class="material-icons account-menu-icon">account_circle</i>
			</template>
			<b-dropdown-item href="#" class="username-item">{{user.name}}</b-dropdown-item>
			<b-dropdown-item href="#">{{user.email}}</b-dropdown-item>

			<b-dropdown-divider/>

			<slot></slot>

			<b-dropdown-item id="logout-button" @click="logout()">Sair</b-dropdown-item>
		</b-nav-item-dropdown>
	</b-navbar-nav>
</template>

<script>

export default {
  data() {
    return {
      user: {}
    };
  },
  created() {
    this.loadUserInfo();
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    loadUserInfo() {
      if (!this.$store.getters.user.email) this.$store.dispatch("loadUserInfo");
      this.user = this.$store.getters.user;
    }
  }
};
</script>

<style>
.account-menu-icon {
  color: #fff;
  vertical-align: bottom;
}

.username-item {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/main-menu/UserMenu.vue